import { createFileRoute } from '@tanstack/react-router';

import { RetentionPage } from '@/features/commercial/retention-page';

export const Route = createFileRoute('/_app/projects/$projectId/commercial/retention')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <RetentionPage projectId={projectId} />;
}
